export default "__VITE_ASSET__CCcJNUwl__"